
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manual",
      function () {
        return require("private-next-pages/manual/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manual"])
      });
    }
  